import appConstants from '../../../../constants';
import computeClassName from '../../../../utils/computeClassName';
import CCIconSocialFacebook20x20 from '../../../libs/CiscoCore/Icon/Social/Facebook/20x20';
import CCIconSocialTwitter20x20 from '../../../libs/CiscoCore/Icon/Social/Twitter/20x20';
import CCIconSocialLinkedIn20x20 from '../../../libs/CiscoCore/Icon/Social/LinkedIn/20x20';
import CCIconSocialYouTube20x20 from '../../../libs/CiscoCore/Icon/Social/YouTube/20x20';
import CCIconSocialInstagram20x20 from '../../../libs/CiscoCore/Icon/Social/Instagram/20x20';

const constants = Object.freeze({
  CLASSNAME_BASE: '',
  ICON_NAME_COMPONENT_MAPPING: {
    [appConstants.CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_FACEBOOK]: CCIconSocialFacebook20x20,
    [appConstants.CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_TWITTER]: CCIconSocialTwitter20x20,
    [appConstants.CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_LINKEDIN]: CCIconSocialLinkedIn20x20,
    [appConstants.CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_YOUTUBE]: CCIconSocialYouTube20x20,
    [appConstants.CDC_LINK_ICON_COMPONENT_NAME_SOCIAL_INSTAGRAM]: CCIconSocialInstagram20x20,

  }
});

export default function SocialLinks({ className = ''}) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  return (
    <p className={computedClassName}>
      {
        appConstants.CDC_LINKS.social.map((link, index) => {
          const ComputedIconComponent = constants.ICON_NAME_COMPONENT_MAPPING[link.iconComponentName];
          return (
            <a className={index === 0 ? 'inline-block' : 'inline-block ml-6 sm:ml-8' }
               href={link.url}
               title={link.title}
               target={link.target}
               key={index}>
              <ComputedIconComponent className="w-5 h-5"/>
            </a>
          );
        })
      }
    </p>
  );
}
